document.addEventListener('DOMContentLoaded', function () {

  /* --------------------------------
     AUTOMATIC "IN THIS ARTICLE" LINKS
  -------------------------------- */

  const articleBody = document.querySelector('.sv-journal-article-body');
  const jumpNav = document.querySelector('.sv-journal-jump__links');

  if (articleBody && jumpNav) {
    const headings = articleBody.querySelectorAll('h2');

    if (headings.length < 2) {
      const jumpSection = document.querySelector('.sv-journal-jump');

      if (jumpSection) {
        jumpSection.style.display = 'none';
      }
    } else {
      headings.forEach(function (heading, index) {
        let headingId = heading.id;

        if (!headingId) {
          headingId = heading.textContent
            .trim()
            .toLowerCase()
            .replace(/&/g, 'and')
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-');

          if (!headingId) {
            headingId = 'section-' + (index + 1);
          }

          let uniqueId = headingId;
          let counter = 2;

          while (document.getElementById(uniqueId)) {
            uniqueId = headingId + '-' + counter;
            counter++;
          }

          heading.id = uniqueId;
          headingId = uniqueId;
        }

        const link = document.createElement('a');

        link.href = '#' + headingId;
        link.textContent = heading.textContent.trim();

        jumpNav.appendChild(link);
      });
    }
  }


  /* --------------------------------
     MOBILE "SHOP THIS ARTICLE" POSITION
  -------------------------------- */

  const sidebar = document.querySelector('.sv-journal-sidebar');
  const mobileShopAnchor = document.querySelector('.sv-journal-mobile-shop-anchor');

  if (sidebar && mobileShopAnchor) {

    const desktopMarker = document.createComment('SV journal sidebar desktop position');

    sidebar.parentNode.insertBefore(desktopMarker, sidebar);

    const mobileQuery = window.matchMedia('(max-width: 989px)');

    function positionShopSidebar() {

      if (mobileQuery.matches) {

        /* Mobile/tablet:
           move products after Key Takeaway
        */

        mobileShopAnchor.insertAdjacentElement('afterend', sidebar);

      } else {

        /* Desktop:
           return products to right-hand column
        */

        if (desktopMarker.parentNode) {
          desktopMarker.parentNode.insertBefore(
            sidebar,
            desktopMarker.nextSibling
          );
        }

      }
    }

    positionShopSidebar();

    mobileQuery.addEventListener('change', positionShopSidebar);
  }

});